import React, { useEffect, useState } from 'react'
import A4Page from '../A4Page'
import TopDetail from '../TopDetail'
import Page1 from './Page1'
import Page2Kids from './Page2Kids'
import PageBigFour from './Pagebigfour'
import Label11 from './Label11'
import PageAccWoman from './PageAccWoman'
import { ReactComponent as Zaraön } from '../../../../../assets/zarahome/zarahomeön.svg'
import { ReactComponent as ZaraönFronot } from '../../../../../assets/zarahome/ZaraHomeFront.svg'
import { ReactComponent as ZaraönFronotKids } from '../../../../../assets/zarahome/zarahomekidsfront.svg'



import useOrderStore from 'store/client/orderStore'
import { IoTriangleOutline } from 'react-icons/io5'
import { IoTriangle } from 'react-icons/io5'
import { ReactComponent as ZaraBom } from '../../../../../assets/DD.svg'
import { ReactComponent as ZaraBomRed } from '../../../../../assets/DDRED.svg'
import { ReactComponent as AUDDOLAR } from '../../../../../assets/DDRED.svg'
import { ReactComponent as ZaraAcc } from '../../../../../assets/zaraaccess01.svg'
import { ReactComponent as ZaraAccLinge } from '../../../../../assets/linnngee.svg'
import { ReactComponent as ZaraAccEmty } from '../../../../../assets/accesemty.svg'
import { ReactComponent as ZaraAccLin } from '../../../../../assets/accesslin.svg'
import { ReactComponent as MyBathroomBig} from '../../../../../assets/pricetopsvg/bathbig.svg'
import { ReactComponent as MyBedroomBig } from '../../../../../assets/pricetopsvg/bedroombig.svg'
import { ReactComponent as MyCosmeticsBig } from '../../../../../assets/pricetopsvg/cosmeticsbig.svg'
import { ReactComponent as MyKidsBig } from '../../../../../assets/pricetopsvg/kidsbig.svg'
import { ReactComponent as MyKitchenBig } from '../../../../../assets/pricetopsvg/kitchenbig.svg'
import { ReactComponent as MyLivingRoomBig } from '../../../../../assets/pricetopsvg/livingroombig.svg'
import { ReactComponent as MyShowcaseBig } from '../../../../../assets/pricetopsvg/showcasebig.svg'



import { ReactComponent as MyBathroomLittle} from '../../../../../assets/pricetopsvg/littlepricezarahome/bathroomlittle.svg'
import { ReactComponent as MyBedroomLittle } from '../../../../../assets/pricetopsvg/littlepricezarahome/bedroomlittle.svg'
import { ReactComponent as MyCosmeticsLittle } from '../../../../../assets/pricetopsvg/littlepricezarahome/cosmeticslittle.svg'
import { ReactComponent as MyKidsLittle } from '../../../../../assets/pricetopsvg/littlepricezarahome/kidslittle.svg'
import { ReactComponent as MyKitchenLittle } from '../../../../../assets/pricetopsvg/littlepricezarahome/kitchenlittle.svg'
import { ReactComponent as MyLivingRoomLittle } from '../../../../../assets/pricetopsvg/littlepricezarahome/livingroomlittle.svg'
import { ReactComponent as MyShowcaseLittle } from '../../../../../assets/pricetopsvg/littlepricezarahome/showcaselittle.svg'



import { ReactComponent as MySVG14 } from '../../../../../assets/pricetopsvg/KIDSBABYGIRL.svg'
import { ReactComponent as MySVG15 } from '../../../../../assets/pricetopsvg/KIDSBOYKARE.svg'
import { ReactComponent as MySVG16 } from '../../../../../assets/pricetopsvg/KIDSGIRLDAIRE.svg'
import { ReactComponent as MySVG17 } from '../../../../../assets/pricetopsvg/KIDSBABYUNIT.svg'
import { ReactComponent as Red } from '../../../../../assets/zarahome/path1039.svg'
import { ReactComponent as Blue } from '../../../../../assets/zarahome/path1045.svg'
import { ReactComponent as Path419 } from '../../../../../assets/zarahome/path419.svg'
import { ReactComponent as Path1 } from '../../../../../assets/zarahome/path1.svg'



import Label12 from './Label12'

import { ReactComponent as ZaraLittleLeft } from '../../../../../assets/zarahome/zaralittleleft.svg'
import { ReactComponent as ZaraLittleKids } from '../../../../../assets/zarahome/zaralittlekids.svg'
import { ReactComponent as ZaraVector } from '../../../../../assets/zarahome/VECTORRRR.svg'
import { ReactComponent as ZaraVectorKids } from '../../../../../assets/zarahome/VECTORRRRKIDS.svg'
import { ReactComponent as ZaraLabel11 } from '../../../../../assets/zarahome/label11back.svg'
import { ReactComponent as ZaraLabel11Kids } from '../../../../../assets/zarahome/label11backkids.svg'


import Label10 from './Label10'

import requests from 'service/api'



import DynamicTextLeftt from './DynamicShrinkLefft'
import { use } from 'react'
const Label12Dynamic = ({ data, selectColor, tab }, ref) => {
  const department = data.department
  const datt =data;
  const [brand, category, subCategory] = department.split(' / ')
  const [SouthAmerica, setSouthAmerica] = useState(false)
  const [loading, setLoading] = useState(true);
  const [cardType, setcardType] = useState('');
  const [homeProducts, setHomeProducts] = useState([])
  const [labelLittle, setLabelLittle] = useState([])
  const [productDescriptions, setProductDescriptions] = useState({}) // Product description cache
  const [processedDescriptions, setProcessedDescriptions] = useState({}) // Processed descriptions cache
  const [x, setx] = useState(7.5)
  const [y, sety] = useState(107.2)

  const [xlitte, setxlittee] = useState(7.5)
  const [ylittle, setylittle] = useState(107.2)
  const [harmacn, setHarmacn] = useState(false) // harmacn state'i

  const { referance } = useOrderStore()
console.log("saksafonnn",data)


  function splitCurrency(value) {
    // Sayıyı string'e çevir
    const stringValue = value.toString()

    // Ondalık noktaya göre ayır
    let [integerPart, decimalPart] = stringValue.split('.')

    // Ondalık kısmı kontrol et ve düzenle
    if (!decimalPart) {
      // Ondalık kısım yoksa, 00 olarak ayarla
      decimalPart = '00'
    } else if (decimalPart.length === 1) {
      // Ondalık kısım tek haneliyse, sonuna bir 0 ekle
      decimalPart += '0'
    } else if (decimalPart.length > 2) {
      // Ondalık kısım iki haneden fazlaysa, ilk iki haneyi al
      decimalPart = decimalPart.substring(0, 2)
    }

    // Sonuçları döndür
    return [integerPart, decimalPart]
  }


  const renderShape = (category) => {
    if (category === 'Bathroom') {
      switch (category) {
        
        case 'Bathroom':
  
          return (
            <MyBathroomBig 
            style={{
          width: '8.712mm',
              height: "auto",
            }}
          />


          ) 
          
  

        default:
          return (
            <></>
          )
      }
    } 
    else if (category === 'Bedroom') {
      switch (category) {
   
        case 'Bedroom':
          return (
            <MyBedroomBig 
            style={{
              width: '7mm',
            height: "auto",
            }}
          />
          )

  

        default:
          return (
            <></>
          )
      }
    } 
    else if (category === 'Cosmetics') {
      switch (category) {
   
        case 'Cosmetics':
          return (
            <MyCosmeticsBig 
            style={{
              width: '7mm',
              height: '7mm',
            }}
          />
          )

  

        default:
          return (
            <></>
          )
      }
    } 
    else if (category === 'Kids') {
      switch (category) {
   
        case 'Kids':
          return (
            <MyKidsBig 
            style={{
              width: '7mm',
              height: "auto",
            }}
          />
          )

  

        default:
          return (
            <></>
          )
      }
    } 
    else if (category === 'Kitchen') {
      switch (category) {
   
        case 'Kitchen':
          return (
            <MyKitchenBig 
            style={{
              width: '7mm',
             height: "auto",
            }}
          />
          )

  

        default:
          return (
            <></>
          )
      }
    } 
    else if (category === 'Living Room') {
      switch (category) {
   
        case 'Living Room':
          return (
            <MyLivingRoomBig 
            style={{
              width: '7.361mm',
             height: "auto",
            }}
          />
          )

  

        default:
          return (
            <></>
          )
      }
    } 
    else if (category === 'Showcase') {
      switch (category) {
   
        case 'Showcase':
          return (
            <MyShowcaseBig 
            style={{
              width: '7.4mm',
              height: "auto",
            }}
          />
          )

  

        default:
          return (
            <></>
          )
      }
    } 
  }
  const renderShape2 = (category) => {
    if (category === 'Bathroom') {
      switch (category) {
        case 'Bathroom':
          return (
            <MyBathroomBig 
            style={{
              width: '6.351mm',
              height: "auto",
            }}
          />
          )
        default:
          return <></>
      }
    } 
    else if (category === 'Bedroom') {
      switch (category) {
        case 'Bedroom':
          return (
            <MyBedroomBig 
            style={{
              width: '4.639mm',
              height: "auto",
            }}
          />
          )
        default:
          return <></>
      }
    } 
    else if (category === 'Cosmetics') {
      switch (category) {
        case 'Cosmetics':
          return (
            <MyCosmeticsBig 
            style={{
              width: '5.4mm',
              height: 'auto',
            }}
          />
          )
        default:
          return <></>
      }
    } 
    else if (category === 'Kids') {
      switch (category) {
        case 'Kids':
          return (
            <MyKidsLittle 
            style={{
              width: '5.4mm',

              height: "auto",
            }}
          />
          )
        default:
          return <></>
      }
    } 
    else if (category === 'Kitchen') {
      switch (category) {
        case 'Kitchen':
          return (
            <MyKitchenLittle 
            style={{
              width: '5mm',
            height: "auto",
            }}
          />
          )
        default:
          return <></>
      }
    } 
    else if (category === 'Living Room') {
      switch (category) {
        case 'Living Room':
          return (
            <MyLivingRoomBig 
            style={{
              width: '5mm',
              height: "auto",
            }}
          />
          )
        default:
          return <></>
      }
    } 
    else if (category === 'Showcase') {
      switch (category) {
        case 'Showcase':
          return (
                <MyShowcaseBig 
              style={{
                width: '5.8mm',
                height: "auto",
              }}
            />
          )
        default:
          return <></>
      }
    } 
  }



  useEffect(() => {
    console.log("innercategorydataaa",data.referance.id==="68bf82f53da0868b30dcb666")
   if(data.referance.id==="68bf82f53da0868b30dcb666")
   {
       if (category === 'Bathroom') {
         setx(7.9)
         sety(107.4)
       } 
       else if (category === 'Bedroom') {
         setx(5.4)
         sety(107.4)
       }
       else if (category === 'Cosmetics') {
         setx(4.9)
         sety(107.4)
       }
       else if (category === 'Kids') {
         setx(4.7)
         sety(107.575)
       }
       else if (category === 'Kitchen') {
         setx(4.9)
         sety(107.4)
       }
       else if (category === 'Living Room') {
         setx(6.5)
         sety(107.4)
       }
       else if (category === 'Showcase') {
         setx(4.7)
         sety(107.4)
       }
     }
   else if(data.referance.id==="68bf8d5d2b0a17ff6fc37315")
   {
     if (category === 'Bathroom') {

      setx(8)
      sety(108.6)
     } 
     else if (category === 'Bedroom') {
      setx(5.3)
      sety(108.4)
     }
     else if (category === 'Cosmetics') {
      setx(5)
      sety(108.4)
     }

     else if (category === 'Kids') {
      setx(4.9)
      sety(108.6)
     }


     else if (category === 'Kitchen') {
      setx(4.9)
      sety(108.6)
     }



     else if (category === 'Living Room') {
      setx(5.9)
      sety(108.6)
     }
     else if (category === 'Showcase') {
      setx(4.8)
      sety(108.6)
     }
   }
   }
     , [category])
     


  
  useEffect(() => {
    const fetchData = async () => {
      // South America kontrolü
      if (data.brandOrderNo && data.brandOrderNo.trim().endsWith('-25')) {
        setSouthAmerica(true);
      } else {
        setSouthAmerica(false);
      }
  
      setcardType(data.zaraHomeLabel12[0].cardType);
  
      try {
        const response = await requests.homeproducts.list();
        const products = response.data.products;
        setHomeProducts(products);
        
        // Product description'ları önceden çek ve cache'le
        const descriptions = {};
        const processed = {};
        products.forEach(product => {
          if (product.id && product.text) {
            descriptions[product.id] = product.text;
            
            // Processed descriptions'ı da hesapla
            const parts = product.text.split(" / ").map(p => p.trim());
            processed[product.id] = {
              fullText: product.text,
              partzero: parts[0] || "",
              parttwo: parts[2] || "",
              partthree: parts[3] || "",
              parttwoandthree: (parts[2] || "") + " / " + (parts[3] || ""),
              partzerokids: (parts[0] || "") + " / " + (parts[2] || ""),
              parttwoandthreekids: parts[3] || ""
            };
          }
        });
        setProductDescriptions(descriptions);
        setProcessedDescriptions(processed);
        console.log('Product descriptions cached:', Object.keys(descriptions).length, 'items');
        console.log('Processed descriptions cached:', Object.keys(processed).length, 'items');
      } catch (error) {
        console.error('Home products çekilirken hata oluştu:', error);
      }
  
      // Harmacn kontrolü
      if (data.companyId === "6562742a5b252fdddcc588e7") {
        setHarmacn(true);
      } else {
        setHarmacn(false);
      }
    };
  
    fetchData();
  }, [data.brandOrderNo]);
  
  useEffect(() => {
    if(referance)
    {
      setLabelLittle(referance.code);
    }
  }, [referance]);



  function getCurrencySymbol(type) {
    switch (type) {
      case 'AUD':
        return '$' // Avustralya Doları için dolar işareti
      case 'USD':
        return '$' // Avustralya Doları için dolar işareti
      case 'EUR':
        return '€' // Euro için euro işareti
      case 'BRL':
        return 'R$' // Brezilya Reali için Real işareti
      case 'GBP':
        return '£' // Brezilya Reali için Real işareti
      case 'CLP':
        return '$' // Brezilya Reali için Real işareti
      default:
        return '' // Diğer durumlar için boş string (veya belki başka bir varsayılan sembol)
    }
  }

  const [currentShape, setCurrentShape] = useState(null)
  const isBlack = referance?.backgroundColor === 'B'

  // item.amount > 0 koşulunu sağlayan öğeleri filtrele ve her 8 öğede bir grupla
  const filteredAndGroupedSizes = data.zaraHomeLabel12[selectColor].sizes
    .filter((item) => item.amount > 0)
    .reduce((acc, item, index) => {
      const groupIndex = Math.floor(index / 1) // Her 3 öğe için bir grup indeksi
      if (!acc[groupIndex]) {
        acc[groupIndex] = { items: [], startIndex: index - (index % 1) } // Yeni bir grup oluştur
      }
      acc[groupIndex].items.push(item)
      return acc
    }, [])

  return (
    
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }} ref={ref}>
    
      {filteredAndGroupedSizes.map((groupObj, groupIndex) => (
        <A4Page
  key={groupIndex}
  type="dikey"
  
>
          <div className="space-y-5" style={{ position: 'relative' }}>
            {labelLittle === 'LABEL 12' ? (
           <></>
            ) : null}
            <TopDetail 
  values={data} 
  selectColor={selectColor} 
  tab={tab} 
  selectedFscTopLogo={data.company?.fsctoplogo || "defaultLogo"} // ✅ Prop geçildi
/>  
            <div style={{ display: 'flex', justifyContent: 'flex-start', marginLeft: data.referance.code.includes("LABEL 10 388X70") ? 10 : 22 }}>
        

         
              {groupObj.items.map((sizeData, index) => {
                // sizeData'dan mix verilerini çek
              
                const [integerPart, decimalPart] = sizeData?.mixed && sizeData.mixed[0] ? splitCurrency(sizeData.mixed[0].currency) : ['', '']
                const [integerPart2, decimalPart2] = sizeData?.mixed && sizeData.mixed[1] ? splitCurrency(sizeData.mixed[1].currency) : ['', '']
                const currencySymbol = sizeData?.mixed && sizeData.mixed[0] ? getCurrencySymbol(sizeData.mixed[0].currencyType) : ''
                const currencySymbol2 = sizeData?.mixed && sizeData.mixed[1] ? getCurrencySymbol(sizeData.mixed[0].currencyType) : ''

                let integerPart3, decimalPart3, currencySymbol3, integerPart4, decimalPart4, currencySymbol4

                if (sizeData?.mixed && sizeData.mixed.length > 2) {
                  ;[integerPart3, decimalPart3] = splitCurrency(sizeData.mixed[2].currency)
                  currencySymbol3 = getCurrencySymbol(sizeData.mixed[2].currencyType)
                } else {
                  integerPart3 = decimalPart3 = currencySymbol3 = ''
                }

                if (sizeData?.mixed && sizeData.mixed.length > 3) {
                  ;[integerPart4, decimalPart4] = splitCurrency(sizeData.mixed[3].currency)
                  currencySymbol4 = getCurrencySymbol(sizeData.mixed[3].currencyType)
                } else {
                  integerPart4 = decimalPart4 = currencySymbol4 = ''
                }

                return (
                  <div key={index}>
                    {labelLittle === 'LABEL 12' ? (
                     <></>
                    ) : null}

                    <div className="printable" style={{ position: 'relative', marginRight: 10 }}>
                      {labelLittle === 'LABEL 12' ? (
                          <Label12
                                    key={groupObj.startIndex + index}
                            selectColor={selectColor}
                            barcodeValue={`4${data?.articleNo?.split('/')[0]}${data?.articleNo?.split('/')[1]}${data?.zaraHomeLabel12[selectColor]?.colorCode}${sizeData.sCode ? sizeData.sCode : ''}`}
                            data={data}
                            qrcodeValue={`4${data?.articleNo?.split('/')[0]}${data?.articleNo?.split('/')[1]}${data?.zaraHomeLabel12[selectColor]?.colorCode}${sizeData.name ? sizeData.name : ''}`}

                            harmacn={harmacn}
                            homeProducts={homeProducts}
                            productDescriptions={productDescriptions}
                            processedDescriptions={processedDescriptions}
                            renderShape={renderShape(category)}
                            Path1={Path1}
                            x={x}
                            y={y}
                            cardType={cardType}
                            SouthAmerica={SouthAmerica}
                            sizeData={sizeData}
                            indo={data?.zaraHomeLabel12[0]?.sizes}
                            szrgrp={data?.sizeGroup}
                            inx={groupObj.startIndex + index}
                            integerpart3={integerPart3}
                            currencysymbol3={currencySymbol3}
                            decimalpart3={decimalPart3}
                            decimalpart4={decimalPart4}
                            integerpart4={integerPart4}
                            currencysymbol4={currencySymbol4}
                            rifd={data.zaraHomeLabel12[0].rifd}
                          />
                        ) : null}
                    </div>
                        
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        textAlign: 'center',
                        alignItems: 'center',
                        gap: '20px',
                        marginRight: labelLittle === 'LABEL 12' ? -800 : 12,
                        position:"relative",
                        marginTop: labelLittle === 'LABEL 12' ? 100 : 0,
                        paddingLeft: 0,
                 
                      }}
                    >
                          <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexWrap: "nowrap",
      transition: "transform 0.3s ease",
      position: "absolute",
      width:102,
      bottom: 140.2,
 left: labelLittle === 'LABEL 12' ? 464 : 58,
      height:25
    }}
  >
          <p
            className="helve-bold"
            style={{ marginRight: "7px",marginBottom:-6,marginLeft:-2.4 }}
          >
           <Path419 style={{width:"3.584mm",height:"auto"}}/>
          </p>
          <p
className='helveboldnarrownew'
  style={{
    fontSize: 26.9,
    letterSpacing: "0",
    color: "black",
    transform: "scaleX(1.2)", // 1.0 = normal, >1 geniş, <1 dar
  }}
>
           {integerPart}
          </p>
      {sizeData?.mixed?.[0]?.currencyType !== "CLP" && (
            <p
              className="helveboldnarrownew"
              style={{
                fontSize: 13.4,
                marginTop: "-6px",
                marginLeft: "5px",
                marginRight:-0.2,
                transform: "scaleX(1.2)", // 1.0 = normal, >1 geniş, <1 dar

                letterSpacing:"0"
              }}
            >
             {decimalPart}
            </p>
          )}
        </div>
                 <Red style={{width:"37.225mm",height:"auto"}}></Red>
                 <Blue style={{width:"45.138mm",height:"auto"}}></Blue>
                 <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexWrap: "nowrap",
      transition: "transform 0.3s ease",
      position: "absolute",
      width:102,
      bottom: 36.2,
      left: labelLittle === 'LABEL 12' ? 464 : 58,
      height:25
    }}
  >
          <p
            className="helve-bold"
            style={{ marginRight: "7px",marginBottom:-6,marginLeft:-2.4 }}
          >
           <Path419 style={{width:"3.584mm",height:"auto"}}/>
          </p>
          <p
className='helveboldnarrownew'
  style={{
    fontSize: 26.9,
    letterSpacing: "0",
    transform: "scaleX(1.2)", // 1.0 = normal, >1 geniş, <1 dar
   
  }}
>
           {integerPart2}
          </p>
      {sizeData?.mixed?.[0]?.currencyType !== "CLP" && (
            <p
              className="helveboldnarrownew"
              style={{
                fontSize: 13.4,
                marginTop: "-6px",
                marginLeft: "5px",
                marginRight:-0.2,
                transform: "scaleX(1.2)", // 1.0 = normal, >1 geniş, <1 dar

                letterSpacing:"0"
              }}
            >
             {decimalPart2}
            </p>
          )}
        </div>
                      </div>
                     
           
          
                  </div>
                )
              })}
            </div>
      
          </div>
        </A4Page>
      ))}
    </div>
  )
}

export default React.forwardRef(Label12Dynamic)
